'use strict';
(()=>{
  const frame=document.querySelector('iframe.mncs-frame');
  if(!frame||typeof NeonFanChain==='undefined'||typeof NeonQuoteData==='undefined')return;
  const frameUrl=new URL(frame.src);
  if(!['/fan-chain.html','/fan-chain-upload-review.html'].includes(frameUrl.pathname))return;
  const origin=frameUrl.origin,root=window.Shopify?.routes?.root||'/';
  const send=(type,payload={})=>frame.contentWindow.postMessage({type,version:1,...payload},origin);
  let busy=false;
  const hello=()=>send('mn:fan-chain-hello',{enabled:true,draft:window.Shopify?.theme?.role!=='main'});
  frame.addEventListener('load',hello);hello();
  async function json(url,options={}){
    const response=await fetch(url,{credentials:'same-origin',signal:AbortSignal.timeout(20000),...options});
    const body=await response.json();
    if(!response.ok||body.status)throw Error(body.description||'Shopify could not prepare this Fan Chain.');
    return body;
  }
  async function checkProducts(s){
    const p=NeonFanChain.resolve(s);
    const products=[{product:NeonFanChain.catalog.base,variant:p.base},{product:NeonFanChain.catalog.chains,variant:p.chain},...(s.sparePacks?[{product:NeonFanChain.catalog.battery,variant:p.battery}]:[])];
    for(const {product,variant} of products){
      const live=await json(root+'products/'+product.handle+'.js');
      const v=live.variants?.find(v=>String(v.id)===variant.id.split('/').pop());
      if(!v?.available||v.price!==Math.round(variant.price*100))throw Error('This Fan Chain option is unavailable or its price has changed.');
    }
  }
  async function rollback(id){
    const cart=await json(root+'cart.js'),lines=cart.items?.filter(v=>v.properties?._mn_fan_design_id===id)||[];
    if(lines.length)await json(root+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({updates:Object.fromEntries(lines.map(v=>[v.key,0]))})});
  }
  async function checkout(design,id){
    const error=message=>send('mn:fan-chain-checkout-error',{requestId:id,message});
    if(typeof id!=='string'||!/^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/.test(id)||!NeonFanChain.valid(design?.state)||!['preview','artwork','original'].every(k=>NeonQuoteData.validateFile(design[k]))||design.preview.name!==NeonQuoteData.previewName||design.artwork.name!=='fan-chain-neon-artwork.png')return error('Review the Fan Chain and reselect your logo before checkout.');
    if(design.state.logoSource==='upload'&&design.state.uploadQualityVersion!==1)return error('Choose Edit my upload and create a clear neon preview before checkout. Some logos need a simpler design.');
    if(busy)return error('Your Fan Chain is already being prepared.');
    busy=true;let cartStarted=false;
    try{
      if(!NeonFanChain.canBuy(design.state)){
        send('mn:fan-chain-checkout-preview',{requestId:id,receipt:NeonFanChain.receipt(design.state,id),artworkConfirmed:true});return;
      }
      await checkProducts(design.state);
      const existing=await json(root+'cart.js');cartStarted=true;
      if(!existing.items?.some(v=>v.properties?._mn_fan_design_id===id)){
        const form=new FormData();
        NeonFanChain.items(design.state,id).forEach((item,i)=>{
          form.append('items['+i+'][id]',item.id);form.append('items['+i+'][quantity]',String(item.quantity));
          Object.entries(item.properties).forEach(([k,v])=>form.append('items['+i+'][properties]['+k+']',v));
        });
        for(const [key,label] of [['preview','Design preview'],['artwork','_mn_neon_artwork'],['original','_mn_original_artwork']])form.append('items[0][properties]['+label+']',new File([design[key].bytes],design[key].name,{type:design[key].type}));
        // A lost response may still have added the items. Reconcile before retry.
        try{await json(root+'cart/add.js',{method:'POST',body:form});}
        catch(addError){const reconciled=await json(root+'cart.js');try{NeonFanChain.verifiedCart(reconciled,design.state,id);}catch{throw addError;}}
      }
      NeonFanChain.verifiedCart(await json(root+'cart.js'),design.state,id);
      send('mn:fan-chain-checkout-accepted',{requestId:id});window.location.assign(root+'cart');
    }catch(e){
      if(cartStarted)try{await rollback(id);}catch{e=Error('Please review your cart before trying again. Your Fan Chain design is saved.');}
      error(e.message||'The Fan Chain could not be added. Please try again.');
    }finally{busy=false;}
  }
  window.addEventListener('message',event=>{
    if(event.origin!==origin||event.source!==frame.contentWindow||event.data?.version!==1)return;
    const d=event.data;if(d.type==='mn:fan-chain-ready')hello();
    if(d.type==='mn:fan-chain-resize'&&frame.dataset?.mnFanScroll!=='panel'&&Number.isFinite(d.height)&&d.height>=400&&d.height<=6000){frame.style.height=Math.ceil(d.height)+'px';frame.style.minHeight='0';}
    if(d.type==='mn:fan-chain-checkout')return checkout(d.design,d.requestId);
  });
})();
